/**
 * Acción de REDUX para la autenticación por email y password
 * Recibe como parametros el email y password
 */

import { getApp } from 'firebase/app';
import { getAuth, getMultiFactorResolver } from 'firebase/auth';

import { AUTH } from '../../../application/types';
import { setMfaResolver } from '../../lib/mfa_resolver';

/**
 * Exporta la función de autenticación por email y password
 *
 * Si el usuario tiene TOTP enrolado (Identity Platform), Firebase NO emite
 * el token: lanza `auth/multi-factor-auth-required` con un resolver. El
 * resolver no es serializable, así que se guarda en el singleton
 * application/lib/mfa_resolver.js y a Redux solo van los hints legibles —
 * el modal de verificación TOTP (login/modal_totp.js) completa el sign-in.
 *
 * @param {string} email
 * @param {string} password
 */
export const email = ( email, password ) => ( dispatch, state, firebase ) => {
  return firebase().auth().signInWithEmailAndPassword( email, password )
    .catch( error => {
      if ( error.code === 'auth/multi-factor-auth-required' ) {
        // compat expone error.resolver; si no viene, se obtiene con la API
        // modular (comparte la app/sesión con la instancia compat).
        const resolver = error.resolver
          || getMultiFactorResolver( getAuth( getApp() ), error );
        setMfaResolver( resolver );
        return dispatch({
          type: AUTH.MFA_TOTP_REQUIRED,
          hints: resolver.hints.map( h => ({
            uid: h.uid,
            factorId: h.factorId,
            displayName: h.displayName || null
          }))
        });
      }
      return dispatch({
        type: AUTH.ERROR,
        code: error.code,
        message: error.message
      });
    })
};
